<template>
  <Modal
    width="496"
    v-model.trim="cForm.modal"
    :title="cForm.id ? '编辑' : '新增'"
    :loading="cForm.loading"
    @on-ok="submit"
  >
    <Form
      class="c-form c-form--modal"
      ref="form"
      :model="cForm.model"
      :rules="cForm.rules"
      :label-width="80"
    >
      <Form-item label="姓名" prop="name">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.name"
          placeholder="请输入姓名"
        />
      </Form-item>
      <Form-item label="家属" prop="parentId">
        <c-parent-select
          class="c-form__input"
          :value="cForm.model.parentId"
          @change="
            value => {
              $set(cForm.model, 'parentId', value);
            }
          "
        >
        </c-parent-select>
      </Form-item>
      <Form-item label="性别" prop="gender">
        <Select class="c-form__input" v-model="cForm.model.gender">
          <Option
            v-for="item in dicts.Gender.filter(item => item.value !== 0)"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          >
            {{ item.label }}
          </Option>
        </Select>
      </Form-item>
      <Form-item label="生日" prop="birthday">
        <DatePicker
          class="c-form__input"
          :value="cForm.model.birthday"
          type="date"
          placeholder="请选择生日时间"
          @on-change="
            value => {
              $set(cForm.model, 'birthday', value);
            }
          "
        />
      </Form-item>
    </Form>
  </Modal>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import FormMixin from "view-ui-admin/src/mixins/form";

const module = "students";

@Component({
  mixins: [FormMixin]
})
export default class ListForm extends Vue {
  data() {
    return {
      cForm: {
        id: 0,
        modal: false,
        loading: true,
        model: this.getFormInitModel(),
        rules: {
          name: [
            {
              required: true,
              message: "姓名不能为空"
            }
          ]
        }
      }
    };
  }

  getFormInitModel() {
    return {};
  }

  show(detail) {
    this.cForm.modal = true;

    if (detail && detail.id) {
      this.cForm.id = detail.id;
      this.initFormFields(detail);
    } else {
      this.cForm.id = 0;
    }
  }

  submit() {
    this.$refs.form.validate(async valid => {
      if (valid) {
        const { id, model } = this.cForm;
        const { data } = await this.$store.dispatch(
          `${module}/${id ? "put" : "post"}`,
          {
            id,
            body: model
          }
        );

        this.cForm.modal = false;
        this.$Message.success(`${id ? "编辑" : "新增"}成功`);
        this.$emit("get-list", data);
      }

      this.fixFormButtonLoading();
    });
  }
}
</script>
